export default function inputFocusOutEvent(input, actions, event, btnConfirm) {
  if (input.classList.contains('has-error')) {
    input.classList.remove('has-error');
  }
  actions.classList.add('display--none');
  btnConfirm.classList.remove('display--none');

  const toolTip = event.target.parentElement.querySelector('.tooltip--inline-edit');
  if (toolTip) {
    event.target.parentElement.removeChild(toolTip);
  }
}



// WEBPACK FOOTER //
// ./js/components/tables/inline-edit/events/inputFocusOutEvent.js